import { AxiosError } from 'axios';
import { AnnouncementDetail } from 'web-library/models/Announcements';
import { PaginatedData } from 'web-library/models/List';
import { ApiPathParam } from 'web-library/models/SearchParamSchema';
import { GET_PRIORITY_ANNOUNCEMENTS_URL } from 'web-library/constants/apiUrls';
import { GET_PRIORITY_ANNOUNCEMENT_QUERY_KEY } from 'web-library/constants/queryKeys';
import { useCustomQuery } from '../utils/useCustomQuery';
import axiosClient from '../axiosClient';
import {GenericErrorResponse} from "../typings";

// =============================================================================
// Request & Response Model
// =============================================================================
export interface PriorityAnnouncementRequest {
  announcementType: string;
  apiPathParam: ApiPathParam;
}

// =============================================================================
// Query
// =============================================================================
interface Input {
  onSuccess?: (data: PaginatedData<AnnouncementDetail>) => void;
  onError?: (data: AxiosError<GenericErrorResponse>) => void;
  requestData: PriorityAnnouncementRequest;
  enabled: boolean;
}

export const useGetPriorityAnnouncements = ({
  onSuccess,
  onError,
  requestData,
  enabled,
}: Input) => {
  const getPriorityAnnouncements = async () => {
    const res = await axiosClient.get<PaginatedData<AnnouncementDetail>>(
      GET_PRIORITY_ANNOUNCEMENTS_URL(requestData.announcementType, requestData.apiPathParam)
    );
    return res.data;
  };
  return useCustomQuery(GET_PRIORITY_ANNOUNCEMENT_QUERY_KEY, getPriorityAnnouncements, {
    onSuccess,
    onError,
    enabled,
  });
};
